import { EnvConfig, setConfig } from '@responsive-image/core';

export const setupImageConfig = () => {
  setConfig<EnvConfig>('env', {
    deviceWidths: [320, 464, 640, 750, 828, 960, 1080, 1280, 1668, 1920, 2048, 2560, 3200, 3840],
    fallbackScreenWidth: 1920,
  });
};
